import { render, staticRenderFns } from "./doctorinfo.vue?vue&type=template&id=687a49d2&scoped=true&"
import script from "./doctorinfo.vue?vue&type=script&lang=js&"
export * from "./doctorinfo.vue?vue&type=script&lang=js&"
import style0 from "./doctorinfo.vue?vue&type=style&index=0&id=687a49d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a49d2",
  null
  
)

export default component.exports